import { createSlice } from "@reduxjs/toolkit";

const routerSlice = createSlice({
  name: "router",
  initialState: {
    catalogueId: "1",
    releaseCatalogueName:"",
    sourceId: "12",
    breadcrumbNodes: [],
    selectedSPW: "",
    filters: {},
    urlRelName:"",
    releaseStatus:"",
    searchFormData: {
      ra: "",
      dec: "",
      radius: "",
      cutout_size:"",
      searchBy: "",
    },
    spwFilterUrl: {
      base_url: "",
      id: "",
      catalogue_id: ""
    },
    isDataReleaseChanged:false,
    shouldUploadBatchFile:false,
  },
  reducers: {
    catalogueIdUpdated(state, action) {
      state.catalogueId = action.payload.catalogueId;
    },
    sourceIdUpdated(state, action) {
      state.sourceId = action.payload.sourceId;
    },
    breadcrumbNodesUpdated(state, action) {
      state.breadcrumbNodes = action.payload.breadcrumbNodes;
    },
    filtersUpdated(state, action) {
      state.filters = action.payload.filters;
    },
    selectedSPWUpdated(state, action) {
      state.selectedSPW = action.payload.selectedSPW;
    },
    searchFormDataUpdated(state, action) {
      state.searchFormData = action.payload.searchFormData;
    },
    spwFilterUrlUpdated(state, action) {
      state.spwFilterUrl = action.payload.spwFilterUrl;
    },
    releaseCatalogueNameUpdated(state,action){
      state.releaseCatalogueName=action.payload.releaseCatalogueName;
    },
    urlRelNameUpdated(state, action) {
      state.urlRelName = action.payload.urlRelName;
    },
    isDataReleaseChangedUpdated(state, action) {
      state.isDataReleaseChanged = action.payload.isDataReleaseChanged;
    },
    shouldUploadBatchFileUpdated(state,action){
      state.shouldUploadBatchFile=action.payload.shouldUploadBatchFile
    },
    releaseStatusUpdated(state,action){
      state.releaseStatus=action.payload.releaseStatus

    }
  },
});

export const {
  catalogueIdUpdated,
  sourceIdUpdated,
  breadcrumbNodesUpdated,
  selectedSPWUpdated,
  searchFormDataUpdated,
  filtersUpdated,
  isSpwChangedUpdated,
  spwFilterUrlUpdated,
  releaseCatalogueNameUpdated,
  urlRelNameUpdated,
  isDataReleaseChangedUpdated,
  shouldUploadBatchFileUpdated,
  releaseStatusUpdated
} = routerSlice.actions;
export default routerSlice.reducer;
